import { motion } from 'framer-motion'

export const animateProps = {
  component: motion.div,
  initial: { height: '0' },
  animate: { height: 'auto', transition: { duration: 0.35, ease: 'easeOut' } },
}
